export default {
  name: "bell",

  box: 16,

  svg: `
  <path
    d="M6.1814 14.3701C6.35685 14.6659 6.60969 14.9122 6.91472 15.0845C7.21974 15.2567 7.56628 15.3489 7.91978 15.3517C8.27328 15.3546 8.62139 15.2681 8.92938 15.1008C9.23737 14.9336 9.49448 14.6914 9.67508 14.3985"
    stroke="#0F0F0F"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M12.8572 7.72532V5.77106C12.8572 3.24483 10.5577 1.05225 7.91211 1.05225C6.6097 1.08017 5.36866 1.59131 4.44749 2.47922C3.52632 3.36713 2.99602 4.56335 2.96705 5.81873V7.72532C2.96705 9.89407 1.16211 10.2277 1.16211 11.4432C1.16211 12.5395 3.75826 13.3974 7.91211 13.3974C12.066 13.3974 14.6621 12.5395 14.6621 11.4432C14.6621 10.2277 12.8572 9.89407 12.8572 7.72532Z"
    stroke="#0F0F0F"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
`,
};
